<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/orderquery/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog(3)"
            addShowPower="/orderquery/add"
            buttonName="创建订单"
            :show="true"
            @giveAddDialog="openAddDialog(4)"
            giveCoupons="/orderquery/add3000"
            giveName="创建3000订单"
            :shows="true"
            @checks="openAddDialog(5)"
            forceRefund="/orderquery/buypick"
            forceName="购买礼包"
            :forceShow="true"
            downloadPower="/orderquery/PeopleExport"
            :showDownloadPower="true"
            @down="down"
            showDownloadPowerType="warning"
        >
            <el-form-item label="支付人ID">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.payUserId"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="代理商ID">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.userId"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="代理商姓名">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.agentName"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="代理商手机号">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.agentPhone"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
                <el-select v-model="formModel.goodName">
                    <el-option
                        v-for="item in TopgoodsTypes"
                        :key="item.id"
                        :label="item.goodName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单号">
                <el-input
                    v-model="formModel.orderNo"
                    maxlength="50"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
                <el-select v-model="formModel.orderStatus">
                    <el-option
                        v-for="item in topStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动策略">
                <el-select v-model="formModel.activityStrategy" clearable>
                    <el-option
                        v-for="item in activityStrategyType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否帮他人购买方式">
                <el-select v-model="formModel.otherBuyFlag">
                    <el-option
                        v-for="item in otherBuyFlagList"
                        :key="item.payTypeCode"
                        :label="item.payTypeName"
                        :value="item.payTypeCode"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付方式">
                <el-select v-model="formModel.payTypeCode">
                    <el-option
                        v-for="item in shoppaymentList"
                        :key="item.payTypeCode"
                        :label="item.payTypeName"
                        :value="item.payTypeCode"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="硬件产品类型">
                <el-select v-model="formModel.hardwareType">
                    <el-option
                        v-for="item in hardwareTypeStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="变更时间">
                <el-date-picker
                    v-model="updateTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="payUserId"
                label="支付人ID"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="agentId"
                label="代理商ID"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
          <span class="blue-text table-text-button"
                @click.self="showParent(scope.row.agentId)"
          >{{ scope.row.agentId }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="agentName"
                label="代理商姓名"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="agentPhone"
                label="代理商手机号"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="orderNo"
                label="订单号"
                min-width="350"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="hardwareType"
                label="硬件产品类型"
                min-width="180"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="status"
                label="订单状态"
                :formatter="formatterTableTrantype"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="dispatchType"
                label="配送方式"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="payTypeCode"
                label="支付方式"
                :formatter="formatterpayTypeCode"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="otherBuyFlag"
                label="是否帮他人购买"
                min-width="150"
                :formatter="formatterTableData"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.otherBuyFlag == 1">是</span>
                    <span v-else-if="scope.row.otherBuyFlag == 0">否</span>
                    <span v-else>--</span>
                </template>
            </el-table-column
            >
            <el-table-column
                prop="activityStrategy"
                label="活动策略"
                :formatter="formatterTableData"
                min-width="300"
                show-overflow-tooltip
            ></el-table-column>
               <el-table-column
                prop="sdAchievement"
                label="收单业绩"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="goodName"
                label="商品名称"
                :formatter="formatterTableData"
                min-width="220"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="orderNumber"
                label="数量"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="orderAmt"
                label="金额"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="payImgUrl" label="支付凭证" min-width="120">
                <template slot-scope="scope">
                    <div
                        class="iconUrl"
                        @click="look(scope)"
                        :style="
              'background:url(' +
              scope.row.payImgUrl +
              ') center/cover no-repeat'
            "
                    ></div>
                </template>
            </el-table-column>
            <el-table-column
                prop="expressName"
                label="快递公司"
                :formatter="formatterTableExpressName"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="expressNo"
                label="快递编号"
                :formatter="formatterTableData"
                min-width="350"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="expressUpdateTime"
                label="快递更新时间"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="receiveName"
                label="收货人姓名"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="receivePhone"
                label="收货人手机号"
                :formatter="formatterTableData"
                min-width="120"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="receiveAddr"
                label="收货人地址"
                :formatter="formatterTableData"
                min-width="200"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                min-width="180"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="updateTime"
                label="修改时间"
                min-width="180"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                min-width="200"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" min-width="260" fixed="right">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="scope.row.status == 6"
                        @click="openAddDialog(1, scope.row)"
                    >审核
                    </el-button
                    >
                    <el-button type="text" @click="openAddDialog(2, scope.row)"
                    >编辑
                    </el-button
                    >
                    <span>
            <el-button
                type="text"
                @click="logisticsInfo(9, scope.row)"
                v-if="scope.row.status == 3 || scope.row.status == 2"
            >查看物流</el-button
            >
            <el-button type="text" v-else :disabled="true"
            >暂无物流信息</el-button
            >
          </span>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="title"
            :model="dialogModel"
            :submitData="dialogData"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            labelWidth="110px"
            class="note"
            :rules="dialogRules"
        >
            <div v-if="type == 1">
                <!-- <div style="display: flex; justify-content: center"> -->
                <el-form-item label="审核" prop="checkStatus">
                    <el-radio v-model="dialogModel.checkStatus" label="0">驳回</el-radio>
                    <el-radio v-model="dialogModel.checkStatus" label="1">通过</el-radio>
                </el-form-item>
                <!-- </div> -->
                <el-form-item
                    label="驳回原因"
                    prop="reason"
                    v-if="dialogModel.checkStatus == 0"
                    style="margin-top: 20px"
                >
                    <el-input
                        v-model="dialogModel.reason"
                        maxlength="180"
                        show-word-limit
                        type="textarea"
                        resize="none"
                        rows="5"
                    ></el-input>
                </el-form-item>
            </div>
            <div v-if="type == 2">
                <el-form-item label="订单号" prop="orderNo">
                    <el-input
                        type="text"
                        maxlength="20"
                        v-model="dialogModel.orderNo"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <el-form-item label="代理商手机号" prop="agentPhone">
                    <el-input
                        type="text"
                        maxlength="20"
                        v-model="dialogModel.agentPhone"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <el-form-item label="代理商名称" prop="agentName">
                    <el-input
                        type="text"
                        maxlength="20"
                        v-model="dialogModel.agentName"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <el-form-item label="订单状态" prop="status">
                    <el-select v-model="dialogModel.status">
                        <el-option
                            v-for="item in topStatus.slice(1, topStatus.length)"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id - 0"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="快递公司" prop="expressName">
                    <el-select v-model="dialogModel.expressName">
                        <el-option
                            v-for="item in ExpressTypes"
                            :key="item.dictValue"
                            :label="item.dictKey"
                            :value="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="快递单号" prop="expressNo">
                    <el-input
                        type="text"
                        maxlength="100"
                        v-model="dialogModel.expressNo"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="收货人姓名" prop="receiveName">
                    <el-input
                        type="text"
                        maxlength="20"
                        v-model="dialogModel.receiveName"
                        placeholder="请输入收货人姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="收货人手机号" prop="receivePhone">
                    <el-input
                        type="text"
                        maxlength="20"
                        v-model="dialogModel.receivePhone"
                        placeholder="请输入收货人手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="收货地址" prop="receiveAddr">
                    <el-input
                        type="text"
                        maxlength="255"
                        v-model="dialogModel.receiveAddr"
                        placeholder="请输入收货地址"
                    ></el-input>
                </el-form-item>
            </div>
            <div v-if="type == 3 || type == 4 || type == 5">
                <div v-if="type == 3">
                    <el-form-item label="商品" prop="goodId">
                        <el-select v-model="dialogModel.goodId">
                            <el-option
                                v-for="item in goodsTypes"
                                :key="item.id"
                                :label="item.goodName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数量" prop="number">
                        <el-input-number
                            style="width: 250px"
                            v-model="dialogModel.number"
                            :min="1"
                            :max="999999999"
                            :step="0"
                            :precision="0"
                            :controls="false"
                            placeholder="请输入"
                        ></el-input-number>
                    </el-form-item>
                </div>
                <el-form-item
                    v-if="type == 3 || type == 4"
                    label="支付方式"
                    prop="buyType"
                >
                    <el-radio-group v-model="dialogModel.buyType">
                        <el-radio :label="0">默认</el-radio>
                        <el-radio :label="1">购买金账户支付</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="type == 3 || type == 4 || type == 5">
                    <el-form-item label="代理商ID" prop="agentId">
                        <el-input
                            type="text"
                            maxlength="100"
                            v-model="dialogModel.agentId"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="代理商姓名" prop="realName">
                        <el-input
                            disabled
                            type="text"
                            maxlength="100"
                            v-model="memName.realName"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="代理商手机号" prop="phoneNumber">
                        <el-input
                            disabled
                            type="text"
                            maxlength="100"
                            v-model="memName.phoneNumber"
                        ></el-input>
                    </el-form-item>
                </div>
                <div v-if="type == 3">
                    <el-form-item label="收货地址" prop="addressId">
                        <el-select v-model="dialogModel.addressId">
                            <el-option
                                v-for="item in shAddress"
                                :key="item.id"
                                :label="`${item.province}-${item.city}-${item.county}-${item.address}`"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div v-if="type == 2 || type == 3">
                <el-form-item label="备注" prop="remark">
                    <el-input
                        v-model="dialogModel.remark"
                        maxlength="80"
                        show-word-limit
                        type="textarea"
                        resize="none"
                        rows="5"
                    ></el-input>
                </el-form-item>
            </div>
            <div v-if="type == 4 || type == 5">
                <el-form-item label="上级代理商ID" prop="parentId">
                    <el-input
                        disabled
                        type="text"
                        maxlength="100"
                        v-model="memName.parentId"
                    ></el-input>
                </el-form-item>
            </div>
            <el-form-item v-if="type == 5" label="商品" prop="goodId">
                <el-select v-model="dialogModel.goodId">
                    <el-option
                        v-for="item in shopping"
                        :key="item.id"
                        :label="item.goodName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </form-dialog>
        <show-info-dialog
            title="支付凭证"
            :show="true"
            ref="showInfoDialog"
            class="showInfoDialog"
        >
            <div v-if="czimgUrl == '' || czimgUrl == null">
                <div
                    style="
            display: flex;
            justify-content: center;
            color: red;
            font-size: 20px;
          "
                >
                    暂未提供支付凭证,还请核实!!!
                </div>
            </div>
            <div v-else>
                <img
                    class="showImage flex-row absolute-center"
                    :src="czimgUrl"
                    alt=""
                    srcset=""
                />
            </div>
        </show-info-dialog>
        <show-info-dialog ref="parentDialog" title="用户层级" :show="true">
            <el-col :span="12"
                v-for="(parentInfo, index) in parentInfoArr"
                :key="index" style="margin-bottom: 15px;"
            >
                <p>
                    {{ parentInfo.name }}：<span v-if="parentInfo.firstLevelNameZ"
                >{{ parentInfo.firstLevelNameZ }} - </span
                ><span
                >{{ parentInfo.levelName }} {{ parentInfo.phoneNumber }}
            {{ parentInfo.realName }}
            {{ parentInfo.id }}</span
                >
                </p>
            </el-col>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";
    import ShowInfoDialog from "../../dialog/ShowInfoDialog";

    import ShopService from "service/ShopService";
    import PosService from "service/PosService";
    import StatisticsService from "service/StatisticsService";
    import FinanceService from "service/FinanceService";
    import MemberService from "service/MemberService";

    import TimeRange from "service/constant/TimeRange";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "orderquery",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
            ShowInfoDialog,
        },
        data() {
            return {
                parentInfoArr:[],
                czimgUrl: "",
                type: "",
                title: "",
                itemId: "",
                tatStatus: "",
                formModel: {
                    userId: "",
                    payUserId: "",
                    agentName: "",
                    agentPhone: "",
                    goodName: "",
                    orderNo: "",
                    orderStatus: "",
                    otherBuyFlag: "",
                    activityStrategy: "",
                    payTypeCode: "",
                    hardwareType: "",
                },
                tableData: [],
                submitService: ShopService.orderqueryList,
                time: TimeRange.monthRange,
                updateTime: [],
                shoppaymentList: [{payTypeCode: "", payTypeName: "全部"}],
                otherBuyFlagList: [
                    {
                        payTypeCode: "",
                        payTypeName: "全部",
                    },
                    {
                        payTypeCode: 0,
                        payTypeName: "否",
                    },
                    {
                        payTypeCode: 1,
                        payTypeName: "是",
                    },
                ],
                status: [],
                dialogRules: {
                    goodId: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                    number: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    agentId: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请输入"));
                                } else {
                                    this.getRealNameByPhone(value, (res) => {
                                        if (res.respCode == "0000") {
                                            this.memName = res.contents;
                                            if (!this.memName.id) {
                                                callback(new Error("查询不到此用户"));
                                                this.memName = "";
                                                this.dialogModel.addressId = "";
                                            } else {
                                                if (this.type == 5 && this.memName.dealerFlag == 0) {
                                                    callback(new Error("此用户不是经销商"));
                                                    this.memName = "";
                                                    this.dialogModel.addressId = "";
                                                } else {
                                                    callback();
                                                }
                                                callback();
                                            }
                                        } else {
                                            callback(new Error("查询不到此用户"));
                                            this.memName = "";
                                            this.dialogModel.addressId = "";
                                        }
                                    });
                                }
                            },
                            trigger: ["change"],
                        },
                    ],
                },
                hardwareTypeStatus: [{id: "", name: "全部"}],
                topStatus: [
                    {
                        id: "",
                        name: "全部",
                    },
                ],
                page: {},
                dialogModel: {
                    userId: "",
                    agentName: "",
                    agentPhone: "",
                    receiveAddr: "",
                    receivePhone: "",
                    status: "",
                    remark: "",
                    expressName: "",
                    expressNo: "",
                    receiveName: "",
                    orderNo: "",

                    checkStatus: "1",
                    reason: "",

                    addressId: "",
                    goodId: "",
                    agentId: "",
                    buyType: 0,
                    number: undefined,
                },
                memId: "",
                isPage: false,
                ExpressTypes: [],
                goodsTypes: [],
                shopping: [],
                TopgoodsTypes: [{id: "", goodName: "全部"}],
                shAddress: [],
                memName: {},
                activityStrategyType: [{dictKey: "", dictValue: "全部"}],
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.getTypeNames("activity_strategy", (res) => {
                this.activityStrategyType = [...this.activityStrategyType, ...res];
            });
            this.getTypeNames("快递公司", (res) => {
                this.ExpressTypes = res;
            });
            this.load();
        },
        computed: {
            submitData() {
                if (this.time == null || this.time == "") {
                    this.time = [];
                }
                if (this.updateTime == null || this.updateTime == "") {
                    this.updateTime = [];
                }
                this.params = {
                    payUserId: this.formModel.payUserId,
                    userId: this.formModel.userId,
                    agentName: this.formModel.agentName.trim(),
                    agentPhone: this.formModel.agentPhone.trim(),
                    orderNo: this.formModel.orderNo.trim(),
                    goodName: this.formModel.goodName,
                    orderStatus: this.formModel.orderStatus,
                    activityStrategy: this.formModel.activityStrategy,
                    otherBuyFlag: this.formModel.otherBuyFlag,
                    payTypeCode: this.formModel.payTypeCode,
                    hardwareType: this.formModel.hardwareType,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.time.length) {
                    this.params.createTimeStart = this.time[0];
                    this.params.createTimeEnd = this.time[1];
                }
                if (this.updateTime.length) {
                    this.params.updateTimeStart = this.updateTime[0];
                    this.params.updateTimeEnd = this.updateTime[1];
                }

                return this.params;
            },
            dialogData() {
                if (this.type == 1) {
                    const params = {
                        checkStatus: this.dialogModel.checkStatus,
                        reason: this.dialogModel.reason,
                    };
                    if (this.itemId) {
                        params.id = this.itemId;
                    }
                    return params;
                } else if (this.type == 2) {
                    const params = {
                        agentName: this.dialogModel.agentName,
                        agentPhone: this.dialogModel.agentPhone,
                        receiveAddr: this.dialogModel.receiveAddr,
                        receivePhone: this.dialogModel.receivePhone,
                        status: this.dialogModel.status,
                        remark: this.dialogModel.remark,
                        expressName: this.dialogModel.expressName,
                        expressNo: this.dialogModel.expressNo,
                        receiveName: this.dialogModel.receiveName,
                        orderNo: this.dialogModel.orderNo,
                    };
                    if (this.itemId) {
                        params.id = this.itemId;
                    }
                    return params;
                } else if (this.type == 3) {
                    const params = {
                        goodId: this.dialogModel.goodId,
                        agentId: this.dialogModel.agentId,
                        number: this.dialogModel.number,
                        addressId: this.dialogModel.addressId,
                        remark: this.dialogModel.remark,
                    };
                    return params;
                } else if (this.type == 4) {
                    const params = {
                        memId: this.dialogModel.agentId,
                        buyType: this.dialogModel.buyType,
                    };
                    return params;
                } else if (this.type == 5) {
                    const params = {
                        memId: this.dialogModel.agentId,
                        goodId: this.dialogModel.goodId,
                    };
                    return params;
                }
            },
            dialogService() {
                if (this.type == 1) {
                    return ShopService.orderqueryShenHe;
                } else if (this.type == 2) {
                    return ShopService.orderqueryEdit;
                } else if (this.type == 3) {
                    return ShopService.orderqueryCreate;
                } else if (this.type == 4) {
                    return ShopService.orderqueryCreate3000;
                } else if (this.type == 5) {
                    return ShopService.orderqueryLb;
                }
            },
            ...mapGetters(["serverType", "tatId", "userId", "orgDetail"]),
        },
        watch: {
            "dialogModel.agentId"(val, oldval) {
                if (!val) {
                    this.dialogModel.addressId = "";
                }
                this.getshAddress(val);
            },
        },
        methods: {
            load() {
                this.formModel = {
                    agentName: "",
                    agentPhone: "",
                    orderNo: "",
                    orderStatus: "",
                    goodName: "",
                    otherBuyFlag: "",
                    activityStrategy: "",
                    payTypeCode: "",
                    hardwareType: "",
                };
                this.page = this.$refs.commonTable.page;
                this.gethardwareTypeStatus();
                this.getshoppaymentList();
                this.gettopStatus();
                this.gettopgoodsType();
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            openAddDialog(type, item) {
                this.type = type;
                switch (this.type) {
                    case 1:
                        this.title = "审核";
                        break;
                    case 2:
                        this.title = "编辑";
                        break;
                    case 3:
                        this.title = "创建订单";
                        break;
                    case 4:
                        this.title = "创建3000订单";
                        break;
                    case 5:
                        this.title = "购买礼包";
                        break;
                    default:
                        break;
                }
                this.itemId = item ? item.id : "";
                if (type == 2) {
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.dialogModel.remark = this.dialogModel.remark
                        ? this.dialogModel.remark
                        : "";
                }
                this.getgoodsType();
                this.getshopping();
                this.$refs.formDialog.open();
            },
            dialogSuccess(res) {
                this.showSuccess(res.respMsg);
                this.$refs.formDialog.closeDialog();
                this.getList();
            },
            dialogClose() {
                this.dialogModel = {
                    agentName: "",
                    agentPhone: "",
                    receiveAddr: "",
                    receivePhone: "",
                    status: "",
                    remark: "",
                    expressName: "",
                    expressNo: "",
                    receiveName: "",
                    orderNo: "",

                    checkStatus: "1",
                    reason: "",

                    addressId: "",
                    goodId: "",
                    agentId: "",
                    buyType: 0,
                    number: undefined,
                };
                this.memId = "";
                this.title = "";
                this.memName = {};
                this.type = "";
                this.itemId = "";
            },
            // 查看物流信息
            logisticsInfo(flag, item) {
                this.$router.push({
                    name: "logisticsinfo",
                    params: {
                        logisticsinfoinfo: JSON.stringify(item),
                        flag: flag,
                    },
                });
            },
            down() {
                this.limitExport(this.page.total)
                    ? StatisticsService.exportExcel(
                    this.submitData,
                    "export",
                    "9000",
                    "/goods/order/"
                    )
                    : "";
            },
            gethardwareTypeStatus() {
                //硬件产品类型
                this.doLoad(
                    PosService.posYingJianType,
                    "",
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.hardwareTypeStatus = [
                                ...this.hardwareTypeStatus,
                                ...res.contents,
                            ];
                        });
                    },
                    "信息获取失败"
                );
            },
            getshoppaymentList() {
                //支付方式
                this.doLoad(
                    ShopService.shoppaymentList,
                    "",
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.shoppaymentList = [...this.shoppaymentList, ...res.contents];
                        });
                    },
                    "信息获取失败"
                );
            },
            gettopStatus() {
                this.doLoad(
                    ShopService.topStatus,
                    "",
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.topStatus = [...this.topStatus, ...res.contents];
                        });
                    },
                    "信息获取失败"
                );
            },
            getRealNameByPhone(val, onSuccess) {
                const params = {
                    tatSimpleId: this.tatId,
                    userId: val,
                };
                this.doLoad(
                    FinanceService.getRealNameByPhone,
                    params,
                    (res) => {
                        onSuccess && onSuccess(res);
                    },
                    "信息获取失败"
                );
            },
            getgoodsType() {
                const params = {
                    size: 500,
                    integral: 2,
                    status: 1,
                };
                this.doLoad(
                    ShopService.shopmanageList,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.goodsTypes = res.contents.rows;
                        });
                    },
                    "信息获取失败"
                );
            },
            getshopping() {
                const params = {
                    size: 500,
                    activityStrategy: "lb",
                    status: 1,
                };
                this.doLoad(
                    ShopService.shoppingList,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.shopping = res.contents.rows;
                        });
                    },
                    "信息获取失败"
                );
            },
            gettopgoodsType() {
                const params = {
                    size: 500,
                };
                this.doLoad(
                    ShopService.shopmanageList,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.TopgoodsTypes = [...this.TopgoodsTypes, ...res.contents.rows];
                        });
                    },
                    "信息获取失败"
                );
            },
            getshAddress(val) {
                const params = {
                    userId: val,
                };
                this.doLoad(
                    ShopService.shopmanageAddress,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.shAddress = res.contents;
                        });
                    },
                    "信息获取失败"
                );
            },
            look(scope) {
                this.czimgUrl = scope.row.payImgUrl;
                this.$refs.showInfoDialog.open();
            },
            formatterTableTrantype(row, column, cellValue, index) {
                let value = "";
                this.topStatus.forEach((item) => {
                    if (item.id == cellValue) {
                        value = item.name;
                    }
                });

                return value ? value : "--";
            },
            formatterpayTypeCode(row, column, cellValue, index) {
                let value = "";
                this.shoppaymentList.forEach((item) => {
                    if (item.payTypeCode == cellValue) {
                        value = item.payTypeName;
                    }
                });

                return value ? value : "--";
            },
            formatterTableExpressName(row, column, cellValue, index) {
                let value = "";
                this.ExpressTypes.forEach((item) => {
                    if (item.dictValue == cellValue) {
                        value = item.dictKey;
                    }
                });

                return value ? value : "--";
            },
            showParent(agentId) {
                const params = {
                    id: agentId,
                    simpleTatId: '',
                };
                this.doLoad(
                    MemberService.selectOne,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.parentInfoArr = res.contents.parentInfo;
                            this.$nextTick(() => {
                                this.$refs.parentDialog.open();
                            })
                        });
                    },
                    "信息获取失败"
                );
            },
        },
    };
</script>

<style scoped>
    .iconUrl {
        width: 50px;
        height: 50px;
        margin: auto;
        overflow: hidden;
    }

    .showImage {
        max-width: 100%;
        min-width: 738px;
        min-height: 500px;
        object-fit: contain;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/ShopManagement/OrderQuery.vue